/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Legal_Entity_AddressInputs */

const cs_auth_signup_legal_entity_address = /** @type {(inputs: Auth_Signup_Legal_Entity_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresa`)
};

const en_auth_signup_legal_entity_address = /** @type {(inputs: Auth_Signup_Legal_Entity_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address`)
};

/**
* | output |
* | --- |
* | "Address" |
*
* @param {Auth_Signup_Legal_Entity_AddressInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_legal_entity_address = /** @type {((inputs?: Auth_Signup_Legal_Entity_AddressInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Legal_Entity_AddressInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_legal_entity_address(inputs)
	return cs_auth_signup_legal_entity_address(inputs)
});